exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".annual-report-card[data-v-7e2895bf]{background:#174ea6;min-height:275px}.annual-report-placeholder[data-v-7e2895bf]{align-items:center;background:#174ea6;display:flex;height:170px;justify-content:center}.annual-report-description[data-v-7e2895bf]{color:#4fa3ff;min-height:50px;word-break:break-word}", ""]);

// exports
